
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"11","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 2a2 2 0 012-2h6.667a2 2 0 012 2v6.667a2 2 0 01-2 2H2a2 2 0 01-2-2V2zm7.805 2.471a.667.667 0 10-.943-.942L4.667 5.724l-.862-.862a.667.667 0 10-.943.943l1.333 1.333c.26.26.683.26.943 0l2.667-2.667z","fill":"#28BF7A"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      